import { Link } from "react-router-dom";
import { BookOpen, Bot, ListRestart, MessageCircleQuestion, MessageSquareText, SlidersHorizontal } from "lucide-react";
import { defineModuleUi, useOrg } from "@vixio/data";
import { Meter, lazyPage } from "@vixio/ui";
import "./api";
import { formatUsd } from "./api";
import { useBudget } from "./widget-data";

export * from "./api";
export { AiButton, AiRunNotice, jsonText, useAiPurpose, useAiRun, type AiRunState } from "./AiRun";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const BudgetPage = lazyPage(() => import("./BudgetPage"), "BudgetPage");
const PurposesPage = lazyPage(() => import("./PurposesPage"), "PurposesPage");
const PromptsPage = lazyPage(() => import("./PromptsPage"), "PromptsPage");
const KnowledgePage = lazyPage(() => import("./KnowledgePage"), "KnowledgePage");
const AskPage = lazyPage(() => import("./AskPage"), "AskPage");
const RunsPage = lazyPage(() => import("./RunsPage"), "RunsPage");

function BudgetWidget() {
  const org = useOrg();
  const rows = useBudget(org.id).data ?? [];
  const total = rows.find((r) => r.scope === "org");
  const blocked = rows.filter((r) => r.scope === "purpose" && r.blocked);
  return (
    <div className="vx-stack" style={{ gap: 8 }}>
      <p className="num" style={{ margin: 0 }}>
        <strong>{formatUsd(total?.spent_micros ?? 0)}</strong> <span className="text-2">{total?.budget_micros ? `de ${formatUsd(total.budget_micros)} no mês` : "no mês, sem teto"}</span>
      </p>
      {total?.budget_micros ? <Meter pct={Math.min(100, total.pct ?? 0)} tone={total.blocked ? "crit" : (total.pct ?? 0) >= 80 ? "warn" : undefined} /> : null}
      <p className="text-2" style={{ margin: 0, fontSize: "var(--fs-12)" }}>
        {blocked.length ? <span className="text-crit">{blocked.length} finalidade(s) bloqueada(s) · </span> : null}
        <Link to="/configuracoes/ia">Abrir orçamento de IA</Link>
      </p>
    </div>
  );
}

export default defineModuleUi({
  key: "ai_gateway",
  title: "Central de IA",
  domain: "platform",
  icon: Bot,
  menu: [
    { path: "/configuracoes/ia", label: "IA: orçamento e uso", minRole: "manager", icon: Bot, order: 40, end: true, keywords: "inteligência artificial custo tokens teto gasto openrouter" },
    { path: "/configuracoes/ia/finalidades", label: "IA: finalidades e modelos", minRole: "member", icon: SlidersHorizontal, order: 41, keywords: "modelo preço guardrail reserva fallback" },
    { path: "/configuracoes/ia/prompts", label: "IA: prompts", minRole: "member", icon: MessageSquareText, order: 42, keywords: "instrução sistema versão" },
    { path: "/configuracoes/ia/conhecimento", label: "IA: base de conhecimento", minRole: "member", icon: BookOpen, order: 43, keywords: "rag busca trechos faq vetor arquivo pdf docx upload" },
    { path: "/configuracoes/ia/perguntar", label: "IA: perguntar à base", minRole: "member", icon: MessageCircleQuestion, order: 44, keywords: "pergunta resposta citação fonte rag" },
    { path: "/configuracoes/ia/execucoes", label: "IA: execuções", minRole: "manager", icon: ListRestart, order: 45, keywords: "fila erro reprocessar worker" },
  ],
  routes: [
    { path: "/configuracoes/ia", element: <BudgetPage />, minRole: "manager" },
    { path: "/configuracoes/ia/finalidades", element: <PurposesPage />, minRole: "member" },
    { path: "/configuracoes/ia/prompts", element: <PromptsPage />, minRole: "member" },
    { path: "/configuracoes/ia/conhecimento", element: <KnowledgePage />, minRole: "member" },
    { path: "/configuracoes/ia/perguntar", element: <AskPage />, minRole: "member" },
    { path: "/configuracoes/ia/execucoes", element: <RunsPage />, minRole: "manager" },
  ],
  widgets: [{ key: "ai_gateway.budget", title: "Gasto de IA", minRole: "manager", span: 1, order: 91, element: BudgetWidget }],
});
